export default "__VITE_ASSET__jHH14Ed___"